import React, { useState, useContext } from "react";
import { useSelector } from "react-redux";
import { apiPost, oauthGet } from "helpers/Request";
import { useAuth } from "hooks/Auth";
import { toast } from "react-hot-toast";
import PrimaryButton from "components/Buttons/PrimaryButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { ContentContext } from "context/Content";
import { useFormikContext } from "formik";

function GenerateAltTextField(props) {
    const auth = useAuth();
    const [loading, setLoading] = useState(false);
    const { state } = useContext(ContentContext);
    const { setFieldValue } = useFormikContext();
    const settings = useSelector((state) => state.contentFlow?.settings);

    const requestAltText = (e) => {
        setLoading(true);
        return doRequestAltText({
            uuid: state.content?.uuid,
            url: state.content?.attachment.imgix_url,
        });
    };

    const doRequestAltText = async (data) => {
        const federatedToken = await oauthGet("/api/v2/me/federated-token", {
            activity: "upload",
        });

        if (!federatedToken || !federatedToken.token) {
            toast.error("Unable to generate alt text");
            return;
        }

        return apiPost(
            "/v5/alt-text",
            auth.publication,
            data,
            true,
            () => federatedToken.token
        )
            .then((resp) => {
                if (resp?.alt_text) {
                    setFieldValue("abstract", resp.alt_text);
                } else {
                    toast.error("Unable to generate alt text");
                }

                return resp;
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div>
            <PrimaryButton
                onClick={requestAltText}
                blocking={loading}
                disabled={
                    settings.settings?.ffAltTextGeneration !== true ||
                    !state.content.lock ||
                    state.content.lock.user.uuid !== auth.user.uuid
                }
            >
                <FontAwesomeIcon
                    className="mr-2 text-sm text-white"
                    icon={solid("robot")}
                />
                Generate Alt Text
            </PrimaryButton>
        </div>
    );
}

export default GenerateAltTextField;
